import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { firebase as fb, helpers } from 'redux-firebasev3';

import DumbStatusListItem from '../../components/StatusListItem';
import StatusEdit from '../StatusEdit';
import { statusesPath, userMetaPath } from '../../utils/firebasePaths';

const { dataToJS, pathToJS } = helpers;

@fb(({ teamId, status: { userId } }) => [
  userMetaPath({ teamId, userId }),
])
@connect(
  ({ firebase }, { teamId, status: { userId } }) => ({
    user: dataToJS(firebase, userMetaPath({ teamId, userId })),
    auth: pathToJS(firebase, 'auth'),
  })
)
export default class StatusListItem extends Component {
  static propTypes = {
    auth: PropTypes.object,
    canShowEdit: PropTypes.bool,
    channelId: PropTypes.string.isRequired,
    firebase: PropTypes.object,
    status: PropTypes.object.isRequired,
    teamId: PropTypes.string.isRequired,
    type: PropTypes.string,
    user: PropTypes.object,
  }

  static defaultProps = {
    canShowEdit: true,
  }

  state = {
    isEditing: false,
  }

  handleCancel = () => {
    this.setState({
      isEditing: false,
    });
  }

  handleEdit = () => {
    this.setState({ isEditing: true });
  }

  handleSave = (newText) => {
    const {
      channelId,
      firebase,
      status: { id },
      teamId,
    } = this.props;
    if (!channelId || !teamId || !id) {
      throw new Error('Missing properties, status save aborted.');
    }
    const rootRef = firebase.database().ref();
    const statusPath = `${statusesPath({ channelId, teamId })}/${id}`;
    rootRef.update({
      [`${statusPath}/text`]: newText,
      [`${statusPath}/updatedAt`]: firebase.database.ServerValue.TIMESTAMP,
    }).then(() => {
      this.setState({ isEditing: false });
    });
  }

  render() {
    const {
      auth,
      canShowEdit,
      status,
      type,
      user,
    } = this.props;
    const { isEditing } = this.state;

    const showEdit = status.userId === auth.uid && canShowEdit;

    if (isEditing) {
      return (
        <StatusEdit
          onCancel={this.handleCancel}
          onSave={this.handleSave}
          text={status.text}
        />
      );
    }

    return (
      <DumbStatusListItem
        onEdit={this.handleEdit}
        showEdit={showEdit}
        status={status}
        type={type}
        user={user}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/StatusListItem/index.jsx
 **/